var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"default-wrapper",class:{ type: _vm.type }},[_c('img',{staticClass:"default-library-img",attrs:{"src":_vm.xss.filterUrl(_vm.imageUrl, null, { logType: "js.href/src", reportOnly: false})}}),_vm._v(" "),_c('div',{staticClass:"default-library-text"},[_vm._v("\n    "+_vm._s(_vm.noDataText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }